import CheckBoxIcon from "@mui/icons-material/CheckBox"
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank"
import type { CheckboxProps } from "@mui/material/Checkbox"
import Checkbox from "@mui/material/Checkbox"
import { JSX } from "react/jsx-runtime"

import styles from "./styles"

function CheckboxWrapper(props: JSX.IntrinsicAttributes & CheckboxProps) {
  return (
    <Checkbox
      icon={<CheckBoxOutlineBlankIcon sx={styles.checkboxBorder} />}
      checkedIcon={<CheckBoxIcon />}
      {...props}
    />
  )
}

export default CheckboxWrapper
